
// import { getUserLogo } from 'api/authApiCall';
import React from 'react';


const InvoiceReceipt = ({ invoice, logoUrl }) => {
    const getCurrencySymbol = (countryCode) => {
        const currencyMap = {
            'gh': 'GHS',
            'BFA': 'XOF',
            'CIV': 'XOF',
            'SEN': 'XOF',
            'ng': '₦',
            'TGO': 'XOF',
            'RWA': 'FRw',
        };
        return currencyMap[countryCode] || 'GHS';
    };
    const currency = getCurrencySymbol(invoice?.country_code);
    // const logoUrl = getUserLogo();
    const subtotal = invoice.subtotal || 0;
    return (
        <div id="section-to-print" className="invoice-container">
            <div className="invoice-header">
                <div>
                    {logoUrl ? (
                        <img src={logoUrl} alt="User Logo" style={{ maxWidth: '200px', maxHeight: '100px' }} />
                    ) : (
                        <img src={require("assets/img/brand/aloapp.png")} style={{ maxWidth: '200px', maxHeight: '100px' }} />
                    )}
                </div>
                <div className="invoice-info">
                    <p>Invoice # : {invoice.invoiceId}</p>
                    <p>Created Date : {new Date(invoice.invoice_date).toLocaleDateString()}</p>
                </div>
            </div>

            <div className="address-container">
                <div className="customer-address">
                    <p>Name : {invoice.customer_name}</p>
                    <p>Country : {invoice.customer_country}</p>
                    <p>Address : {invoice.customer_address}</p>
                </div>
            </div>

            <table className="invoice-items">
                <thead>
                    <tr>
                        <th>DESCRIPTION</th>
                        <th>QUANTITY</th>
                        <th>PRICE</th>
                        <th>AMOUNT</th>
                    </tr>
                </thead>
                <tbody>
                    {invoice.products.map((product, index) => (
                        <tr key={index}>
                            <td>{product.product_name}</td>
                            <td>{product.quantity}</td>
                            <td>{product.price}</td>
                            <td>{product.price * product.quantity}</td>
                        </tr>
                    ))}
                </tbody>
            </table>

            <div className="invoice-summary">

                <div className="summary-item">
                    <span>Discount</span>
                    <span> - {(invoice.discount * 100).toFixed(0)}%</span>
                </div>
                <div className="summary-item">
                    <span>Subtotal</span>
                    <span> <strong>{currency} {Number(invoice.subtotal).toFixed(2).replace(/\.00$/, '')}</strong></span>
                </div>
                <div className="summary-item total">
                    <span>Total</span>
                    <span> <strong>{currency} {Number(invoice.subtotal).toFixed(2).replace(/\.00$/, '')}</strong></span>
                </div>
            </div>

            <p className="thank-you">Thank you for your business!</p>

            <footer style={{ marginTop: "200px" }}>
                <small className="text-muted" style={{ fontSize: '10px', marginTop: "500px" }}>
                    OYO Afrique
                </small>

            </footer>
        </div>
    );
};


export default InvoiceReceipt;
